module.exports = __webpack_public_path__ + "img/sacrifice-hand.3d284f9c.svg";